var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnDestroy, OnInit } from '@angular/core';
import { ActiveObjectService } from '../../../image-editor/canvas/active-object/active-object.service';
import { HistoryToolService } from '../../../image-editor/history/history-tool.service';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { MarkAsDirty, OpenObjectSettingsPanel } from '../../state/objects/objects.actions';
import { ObjectsState } from '../../state/objects/objects.state';
import { take } from 'rxjs/operators';
import { EditorState } from '../../../image-editor/state/editor-state';
var ObjectSettingsDrawerComponent = /** @class */ (function () {
    function ObjectSettingsDrawerComponent(activeObject, history, store) {
        this.activeObject = activeObject;
        this.history = history;
        this.store = store;
    }
    ObjectSettingsDrawerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.activeObject.propsChanged$
            .pipe(take(1))
            .subscribe(function () {
            _this.store.dispatch(new MarkAsDirty());
        });
    };
    ObjectSettingsDrawerComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    ObjectSettingsDrawerComponent.prototype.openPanel = function (name) {
        this.store.dispatch(new OpenObjectSettingsPanel(name));
    };
    __decorate([
        Select(ObjectsState.activePanel),
        __metadata("design:type", Observable)
    ], ObjectSettingsDrawerComponent.prototype, "activePanel$", void 0);
    __decorate([
        Select(EditorState.activeObjIsText),
        __metadata("design:type", Observable)
    ], ObjectSettingsDrawerComponent.prototype, "activeObjIsText$", void 0);
    __decorate([
        Select(EditorState.activeObjIsShape),
        __metadata("design:type", Observable)
    ], ObjectSettingsDrawerComponent.prototype, "activeObjIsShape$", void 0);
    return ObjectSettingsDrawerComponent;
}());
export { ObjectSettingsDrawerComponent };
